<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Change Transportation Status for {{ config.data.passenger?.name }}</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content p-spacing-xl border-1 border-neutral-base-primary-border border-round-lg flex flex-column gap-spacing-xl table-bg-hover-bg">
  <form
    #form="ngForm"
    class="flex flex-column gap-spacing-xl">
    <div class="form-group flex flex-column gap-spacing-xs">
      <label
        for="arrivalTimeInput"
        class="input-label label-large-medium text-primary-color">
        Actual Arrival Time <span class="feedback-danger-fg-color">*</span>
      </label>
      <div class="form-group">
        <p-datepicker
          appendTo="body"
          id="arrivalTimeInput"
          [(ngModel)]="arrivalTime"
          (ngModelChange)="onArrivalTimeChange($event)"
          name="arrivalTime"
          placeholder="Actual Arrival Time"
          [iconDisplay]="'input'"
          [showIcon]="true"
          [timeOnly]="true"
          hourFormat="12"
          [required]="true"
          [inputStyleClass]="arrivalTimeError ? 'ng-invalid ng-dirty' : ''"
          inputId="arrivalTimeInput">
          <ng-template #inputicon>
            <i class="icon-clock size-icon-sm icon-light-color"></i>
          </ng-template>
        </p-datepicker>
        @if (arrivalTimeError) {
          <small class="input-helper-text label-medium-regular text-danger-color">
            {{ arrivalTimeError }}
          </small>
        }
      </div>
    </div>

    <div class="flex flex-column gap-spacing-2xs">
      <h6 class="mb-0 label-large-medium text-primary-color">Current Passenger Transportation Status</h6>
      <app-tag
        [content]="config.data.passenger.status || 'Scheduled'"
        sizeClass="tag-sm"
        severityClass="help">
      </app-tag>
    </div>

    <div class="form-group flex flex-column gap-spacing-xs">
      <label
        for="statusInput"
        class="input-label label-large-medium text-primary-color">
        New Passenger Transportation Status <span class="feedback-danger-fg-color">*</span>
      </label>
      <div class="form-group">
        <p-select
          id="statusInput"
          ngModel
          name="status"
          required
          [options]="statusOptions()"
          optionLabel="name"
          dropdownIcon="icon-caret-up-down"
          placeholder="Select New Status" />
      </div>
    </div>

    <div class="form-group flex flex-column gap-spacing-xs">
      <label
        class="input-label flex flex-column gap-spacing-default body-medium-medium text-secondary-color"
        for="reasonInput"
        >Reason
        <span class="body-small-medium text-caption-color">The reason for why you are updating this passenger's transportation status.</span>
      </label>
      <p-autoComplete
        #reasonInput="ngModel"
        #autoCompleteRef
        [(ngModel)]="reason"
        name="reason"
        required
        [suggestions]="filteredSuggestions"
        (completeMethod)="filterSuggestions($event, autoCompleteRef)"
        (onFocus)="filterSuggestions($event, autoCompleteRef)"
        [showEmptyMessage]="false"
        appendTo="body"
        inputStyleClass="px-spacing-md pt-spacing-md"
        [style]="{ width: '100%' }"
        [inputStyle]="{ paddingBottom: '72px', height: '100px' }"
        placeholder="Select or enter a reason." />
    </div>
  </form>
  <div class="warning-messages border-round-md p-spacing-md background-muted-warning-bg flex gap-spacing-xs align-items-center">
    <i class="icon-warning-solid text-xl icon-warning-color"></i>
    <ul class="mb-0 pl-spacing-2xs list-none">
      <li class="label-large-regular text-warning-color">This action will update the passenger status and ride status.</li>
      <li class="label-large-regular text-warning-color">This action will notify the driver and any monitors via push notification.</li>
    </ul>
  </div>
</div>

<div class="footer pb-spacing-3xl pt-spacing-4xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Cancel"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  <app-button
    label="Change status"
    [isLoading]="loading"
    [disabled]="loading || !!form?.invalid || reasonInput.value?.trim().length <= 0 || !!arrivalTimeError"
    [iconStart]="loading ? 'icon-spinner-gap' : ''"
    (btnClick)="confirmAction(form)"
    sizeClass="p-button-md"
    severity="primary"></app-button>
</div>
